import { environment } from './../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(private translate: TranslateService) {
  }

  public init(): void {
    this.translate.addLangs(environment.supportedLanguages ? environment.supportedLanguages.split(',') : ['en']);
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('en');
  }

  public getLanguages(): string[] {
    return this.translate.getLangs();
  }
}
